/*
  Exportación a CSV para las tablas de Contabilidad.

  El destinatario es el contador, que abre el archivo en Excel es-PE. Eso fija
  tres decisiones que no son negociables:

  - **Separador `;`** — Excel en configuración regional peruana espera punto y
    coma. Con `,` mete toda la fila en una sola columna.
  - **BOM UTF-8** — sin él Excel en Windows interpreta el archivo como ANSI y
    "Multa SUNAT" sale como "MultaÂ SUNAT".
  - **CRLF** — terminador de línea de Windows.

  Los egresos se exportan en negativo (lo decide cada página al armar sus
  columnas) para que sumar la columna Total en Excel dé el saldo del período.
*/

export type CsvColumn<T> = [titulo: string, valor: (fila: T) => string | number | null | undefined]

/** Entrecomilla solo si hace falta; las comillas internas se duplican (RFC 4180). */
function escaparCampo(v: string | number | null | undefined): string {
  const t = String(v ?? '')
  return /[";\n\r]/.test(t) ? `"${t.replace(/"/g, '""')}"` : t
}

/** Arma el texto del CSV (sin BOM) a partir de las columnas y las filas. */
export function construirCsv<T>(columnas: CsvColumn<T>[], filas: T[]): string {
  const lineas = [
    columnas.map(c => escaparCampo(c[0])).join(';'),
    ...filas.map(f => columnas.map(c => escaparCampo(c[1](f))).join(';')),
  ]
  return lineas.join('\r\n')
}

/** Construye el CSV y dispara la descarga en el navegador. */
export function descargarCsv<T>(nombreArchivo: string, columnas: CsvColumn<T>[], filas: T[]): void {
  const blob = new Blob(['﻿' + construirCsv(columnas, filas)], { type: 'text/csv;charset=utf-8;' })
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = nombreArchivo.endsWith('.csv') ? nombreArchivo : `${nombreArchivo}.csv`
  a.click()
  URL.revokeObjectURL(url)
}
